import { Success } from '../common.interface';

export interface IReqProducts {
  page?: number;
  page_size?: number;
  sort?: string;
  search?: string;
  onlyActive?: boolean;
  warehouse_detail?: boolean;
}

export interface IResProducts extends Success {
  products: Product[];
}

export interface WarehouseProduct {
  warehouse_id: string;
  warehouse_name: string;
  country: string;
  on_hand: number;
  inventory: number;
  backorder_quantity: number;
  in_progress: number;
}

export interface KitComponent {
  sku: string;
  name?: string;
  thumbnail?: string;
  quantity: number;
}

export interface Product {
  thumbnail: string;
  name: string;
  sku: string;
  internal_sku?: string;
  barcode: string;
  value: number;
  dimensions: Dimensions;
  volume: number;
  stock: number;
  inventory: number;
  leftover: number;
  backorder_quantity: number;
  sold: number;
  active: boolean;
  createdAt: string;
  updatedAt: string;
  price?: number;
  warehouse_products?: WarehouseProduct[];
  is_kit?: boolean;
  kit_build?: boolean;
  kit_components?: KitComponent[];
}

export const getProductId = (product: Pick<Product, 'internal_sku' | 'sku' | 'name'>): string =>
  product.internal_sku || `${product.sku}||${product.name}`;

export interface Dimensions {
  height: number;
  length: number;
  weight: number;
  width: number;
}
